var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "salary_type" }, [
      _c("p", [_vm._v("Низкая ставка з/п")]),
      _vm._v(" "),
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("ставка")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.salaryDetails.low.basic,
                expression: "salaryDetails.low.basic",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number" },
            domProps: { value: _vm.salaryDetails.low.basic },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.salaryDetails.low, "basic", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("+")]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("% сумма")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.salaryDetails.low.rate,
                expression: "salaryDetails.low.rate",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number" },
            domProps: { value: _vm.salaryDetails.low.rate },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.salaryDetails.low, "rate", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("+")]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("(сумма-расходы) *")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.salaryDetails.low.expenses,
                expression: "salaryDetails.low.expenses",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number" },
            domProps: { value: _vm.salaryDetails.low.expenses },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.salaryDetails.low, "expenses", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("+")]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("(ставка надбавки)")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.salaryDetails.low.bonus,
                expression: "salaryDetails.low.bonus",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number" },
            domProps: { value: _vm.salaryDetails.low.bonus },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.salaryDetails.low, "bonus", $event.target.value)
              },
            },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "salary_type" }, [
      _c("p", [_vm._v("Дальняя ставка")]),
      _vm._v(" "),
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("ставка")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.salaryDetails.mid.basic,
                expression: "salaryDetails.mid.basic",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number" },
            domProps: { value: _vm.salaryDetails.mid.basic },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.salaryDetails.mid, "basic", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("+")]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("% сумма")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.salaryDetails.mid.rate,
                expression: "salaryDetails.mid.rate",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number" },
            domProps: { value: _vm.salaryDetails.mid.rate },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.salaryDetails.mid, "rate", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("+")]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("(сумма-расходы) *")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.salaryDetails.mid.expenses,
                expression: "salaryDetails.mid.expenses",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number" },
            domProps: { value: _vm.salaryDetails.mid.expenses },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.salaryDetails.mid, "expenses", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("+")]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("(ставка надбавки)")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.salaryDetails.mid.bonus,
                expression: "salaryDetails.mid.bonus",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number" },
            domProps: { value: _vm.salaryDetails.mid.bonus },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.salaryDetails.mid, "bonus", $event.target.value)
              },
            },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "salary_type" }, [
      _c("p", [_vm._v("Высокая ставка з/п")]),
      _vm._v(" "),
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("ставка")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.salaryDetails.high.basic,
                expression: "salaryDetails.high.basic",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number" },
            domProps: { value: _vm.salaryDetails.high.basic },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.salaryDetails.high, "basic", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("+")]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("% сумма")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.salaryDetails.high.rate,
                expression: "salaryDetails.high.rate",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number" },
            domProps: { value: _vm.salaryDetails.high.rate },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.salaryDetails.high, "rate", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("+")]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("(сумма-расходы) *")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.salaryDetails.high.expenses,
                expression: "salaryDetails.high.expenses",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number" },
            domProps: { value: _vm.salaryDetails.high.expenses },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(
                  _vm.salaryDetails.high,
                  "expenses",
                  $event.target.value
                )
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("+")]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("(ставка надбавки)")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.salaryDetails.high.bonus,
                expression: "salaryDetails.high.bonus",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number" },
            domProps: { value: _vm.salaryDetails.high.bonus },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.salaryDetails.high, "bonus", $event.target.value)
              },
            },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "salary_type" }, [
      _c("p", [
        _vm._v("Индивидуальная ставка з/п (вся сумма доставки курьеру)"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("ставка")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.salaryDetails.personal.basic,
                expression: "salaryDetails.personal.basic",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number" },
            domProps: { value: _vm.salaryDetails.personal.basic },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(
                  _vm.salaryDetails.personal,
                  "basic",
                  $event.target.value
                )
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("+")]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("% сумма")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.salaryDetails.personal.rate,
                expression: "salaryDetails.personal.rate",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number" },
            domProps: { value: _vm.salaryDetails.personal.rate },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(
                  _vm.salaryDetails.personal,
                  "rate",
                  $event.target.value
                )
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("+")]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("(сумма-расходы) *")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.salaryDetails.personal.expenses,
                expression: "salaryDetails.personal.expenses",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number" },
            domProps: { value: _vm.salaryDetails.personal.expenses },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(
                  _vm.salaryDetails.personal,
                  "expenses",
                  $event.target.value
                )
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("+")]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("(ставка надбавки)")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.salaryDetails.personal.bonus,
                expression: "salaryDetails.personal.bonus",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number" },
            domProps: { value: _vm.salaryDetails.personal.bonus },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(
                  _vm.salaryDetails.personal,
                  "bonus",
                  $event.target.value
                )
              },
            },
          }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex mb-2" }, [
      _c("select", {
        staticClass: "form-control",
        attrs: { name: "", id: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }